export interface PreparedLink {
	url: string;
	urlObject: URL | null;
}